export const classAllocations = {
  GLOBAL_EQUITIES: 'globalEquities',
  BALANCED: 'balanced',
  CASH_EQUIVALENTS: 'cashEquivalents',
  GLOBAL_FIXED_INCOME: 'globalFixedIncome',
  ALTERNATIVES: 'alternatives',
  UNASSIGNED: 'unassigned',
}
export const globalEquitiesColor = '#0B5C68'
export const balancedColor = '#6EE3EB'
export const globalFixedIncomeColor = '#0F9A8E'
export const cashEquivalentsColor = '#38CB9F'
export const alternativesColor = '#EBAD04'
export const unassignedColor = '#CBC8C5'

export const GLOBAL_EQUITIES = {
  type: classAllocations.GLOBAL_EQUITIES,
  key: '35921',
  color: globalEquitiesColor,
  name: 'Global Equities',
}
export const BALANCED = {
  type: classAllocations.BALANCED,
  key: '41931',
  color: balancedColor,
  name: 'Multi-Asset',
}
export const GLOBAL_FIXED_INCOME = {
  type: classAllocations.GLOBAL_FIXED_INCOME,
  key: '35931',
  color: globalFixedIncomeColor,
  name: 'Global Fixed Income',
}
export const CASH_EQUIVALENTS = {
  type: classAllocations.CASH_EQUIVALENTS,
  key: '35911',
  color: cashEquivalentsColor,
  name: 'Cash & Equivalents',
}
export const ALTERNATIVES = {
  type: classAllocations.ALTERNATIVES,
  key: '35941',
  color: alternativesColor,
  name: 'Alternatives',
}
export const UNASSIGNED_ASSETS = {
  type: classAllocations.UNASSIGNED,
  key: '35941',
  color: unassignedColor,
  name: 'Unclassified',
}
export const allClassAllocations = [
  GLOBAL_EQUITIES,
  BALANCED,
  GLOBAL_FIXED_INCOME,
  CASH_EQUIVALENTS,
  ALTERNATIVES,
  UNASSIGNED_ASSETS,
]

export const assignedClassAllocations = [
  GLOBAL_EQUITIES,
  BALANCED,
  GLOBAL_FIXED_INCOME,
  CASH_EQUIVALENTS,
  ALTERNATIVES,
]

export const assetsOrder = [{
  className: GLOBAL_EQUITIES.name,
  weight: 0
},{
  className: GLOBAL_FIXED_INCOME.name,
  weight: 1
},{
  className: BALANCED.name,
  weight: 2
},{
  className: ALTERNATIVES.name,
  weight: 3
},{
  className: CASH_EQUIVALENTS.name,
  weight: 4
},{
  className: UNASSIGNED_ASSETS.name,
  weight: 5
}]

export const formatClassName = (className) => {
  let newClassName = className
  if (className === 'Alternative Assets') {
    newClassName = 'Alternatives'
  }

  switch (newClassName) {
    case 'Alternative Assets':
      newClassName = 'Alternatives'
      break
    case 'Balanced':
      newClassName = 'Multi-Asset'
      break
    default:
  }
  return newClassName
}



// WEBPACK FOOTER //
// ./src/utils/Client/classAllocationsConfig.js